import React from 'react'

const TERMS_URL = 'https://www.zocks.io/terms-of-service'
const PRIVACY_URL = 'https://www.zocks.io/privacy-policy'

export const OAuthFooter: React.FC = () => {
  return (
    <div className='text-muted oauth-mb-40'>
      By continuing, you agree to Zocks{' '}
      <a href={TERMS_URL} target='_blank' rel='noopener noreferrer' className='fw-bold text-decoration-underline oauth-link-purple'>
        Terms of Service
      </a>{' '}
      and{' '}
      <a href={PRIVACY_URL} target='_blank' rel='noopener noreferrer' className='fw-bold text-decoration-underline oauth-link-purple'>
        Privacy Policy
      </a>
      .
    </div>
  )
}
